// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"452":"7b3c4184","453":"694633cc"}[chunkId] + ".chunk.js";
};